/**
 * Options for old devices without realtime change
 */

'use strict';

var ids = require('../identifiers'),

    runtimeTvSystemSettings = typeof gSTB.SetDisplayMode === 'function',

    videoModeOptionIndex = 0,

    videoModeNotificationTimeout = 15000,

    pluginConfig, tvSystemOrigin, gettext;


function saveRuntimeVideoMode ( option, value ) {
    gSTB.SetDisplayMode(value, false);
    option.description = [
        {
            label: gettext('Video output mode'),
            value: value
        }
    ];
    pluginConfig.api.actions.setInfo({
        description: option.description
    });
}

/* eslint no-invalid-this: 0 */
function videoModeSaver ( done ) {
    var self = this,
        option = self.section.options[videoModeOptionIndex];

    setTimeout(function () {
        pluginConfig.api.savers.environment.call(self, function () {
            var notificationTimeout = -1,
                notification = core.notify({
                    title: 'All is ok?',
                    icon: 'info',
                    type: '',
                    buttons: [
                        {
                            value: gettext('Cancel'),
                            click: function () {
                                clearTimeout(notificationTimeout);
                                self.environment.tvsystem = tvSystemOrigin;
                                saveRuntimeVideoMode(option, tvSystemOrigin);

                                /* eslint no-useless-call: 0 */
                                // reset focus index in video mode list
                                option.prepareForRender.call(option, {
                                    tvsystem: tvSystemOrigin
                                }, function ( data ) {
                                    option.refresh(data);
                                });
                                done(true);
                            }
                        },
                        {
                            value: gettext('Ok'),
                            click: function () {
                                clearTimeout(notificationTimeout);
                                pluginConfig.api.savers.environment.call(self, done);
                            }
                        }
                    ]
                });

            notificationTimeout = setTimeout(function () {
                notification.close();
                saveRuntimeVideoMode(option, tvSystemOrigin);

                /* eslint no-useless-call: 0 */
                // reset focus index in video mode list
                option.prepareForRender.call(option, {
                    tvsystem: tvSystemOrigin
                }, function ( data ) {
                    option.refresh(data);
                });
                done(true);
            }, videoModeNotificationTimeout);
        });
    }, 0);
}


function generateOptions ( config ) {
    var videoModes = require('../data/video.modes'),
        resolutionsProvider = require('../data/resolutions.provider');

    pluginConfig = config;

    return [
        {
            id: ids.tvSystem,
            name: gettext('Video output mode'),
            description: [
                {
                    label: gettext('Video output mode'),
                    value: core.environment.tvsystem
                }
            ],
            title: gettext('Video output mode'),
            icon: 'theme-icon-display',
            environment: {
                tvsystem: '720p-60'
            },
            prepareForRender: function ( environment, callback ) {
                callback(videoModes.map(function ( videoMode ) {
                    return {
                        value: videoMode.value,
                        name: videoMode.name,
                        selected: environment.tvsystem === videoMode.value
                    };
                }));
            },
            events: {
                'select:item': function ( item ) {
                    var option = this.section.options[videoModeOptionIndex];

                    /* eslint no-useless-call: 0 */
                    option.prepareForRender.call(option, {
                        tvsystem: item.value
                    }, function (data) {
                        option.refresh(data);
                    });

                    // if ( !runtimeTvSystemSettings ) {
                    //     config.api.actions.setInfo({
                    //         description: [
                    //             {
                    //                 label: gettext('Video output mode'),
                    //                 value: item.value
                    //             }
                    //         ]
                    //     });
                    // }
                }
            },
            prepareForSave: function ( value, callback ) {
                if ( runtimeTvSystemSettings ) {
                    tvSystemOrigin = this.environment.tvsystem; /* save current value */
                    saveRuntimeVideoMode(this.section.options[videoModeOptionIndex], value);
                }

                this.environment.tvsystem = value;

                callback();
            },
            saveImmediate: runtimeTvSystemSettings,
            requireDeviceReboot: !runtimeTvSystemSettings,
            render: config.api.renders.popupSelect,
            getter: config.api.getters.environment,
            saver: runtimeTvSystemSettings ? videoModeSaver : config.api.savers.environment,
            parent: ids.video
        },
        {
            id: ids.graphicResolution,
            name: gettext('Graphic resolution'),
            title: gettext('Graphic resolution'),
            description: [
                {
                    label: gettext('Graphic resolution'),
                    value: core.environment.graphicres
                }
            ],
            icon: 'theme-icon-display',
            environment: {
                graphicres: '720'
            },
            prepareForRender: function (environment, callback) {
                callback(resolutionsProvider().map(function ( resolution ) {
                    return {
                        value: resolution.value,
                        name: resolution.name,
                        selected: environment.tvsystem === resolution.value
                    };
                }));
            },
            prepareForSave: function ( value, callback) {
                this.environment.graphicres = value;

                callback();
            },
            requireDeviceReboot: true,
            render: config.api.renders.popupSelect,
            getter: config.api.getters.environment,
            saver: config.api.savers.environment,
            parent: ids.video
        },
        require('./auto.frame.rate')(config)
    ];
}

module.exports = function ( config ) {
    var data;

    gettext = require('mag-gettext').gettext;

    data = {
        id: 'video',
        name: gettext('Video section'),
        description: gettext('Video section general description'),
        // sections   : [
        //     {
        //         id         : ids.video,
        //         name       : gettext('Video'),
        //         description: gettext('System section general description'),
        //         icon       : 'theme-icon-monitor',
        //         parent     : ids.root
        //     }
        // ],
        options: generateOptions(config),
        content: []
    };

    switch ( core.device.model ) {
        case 'emulator':
        case 'emulator_stb':
        case 'AndroidSTB':
        case 'AndroidAPP':
            break;

        default:
            data.options.push(require('./digital.output')(config));
            break;
    }

    return data;
};
